export function scrollToElement(elementId){
	var elem = document.getElementById(elementId);
	if (document.documentElement.clientHeight < elem.getBoundingClientRect().top + elem.offsetHeight) {
        var pos = elem.getBoundingClientRect().top + window.pageYOffset + elem.offsetHeight + 10 - document.documentElement.clientHeight;
        //console.log(elem.getBoundingClientRect().top, elem.offsetHeight, document.documentElement.clientHeight, window.pageYOffset, pos);
        window.scroll({top: pos, left: 0, behavior: 'smooth' })
    }
  //console.log(document.documentElement.clientHeight, '<', elem.getBoundingClientRect().top, '+', elem.offsetHeight);
}
